/**
 * The shell's two pieces of chrome, shared by the app and the admin screens: the viewport that makes the page
 * one screen (there is no stylesheet to size html/body), and the light/dark press.
 */
import { useEffect } from 'react';
import { useTheme } from '../theme';
import { ActionButton, Corner, Hint } from '../strata';

/** The one-screen app: the viewport is the page, and the screens fill
 * it. There is no stylesheet to size html/body, so the root does. */
export function Viewport({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const root = document.getElementById('root');
    for (const el of [document.documentElement, document.body, root]) {
      if (!el) continue;
      el.style.height = '100%';
      el.style.width = '100%';
      el.style.margin = '0';
      el.style.overflow = 'hidden';
    }
  }, []);
  return <>{children}</>;
}

/** Light or dark, one press. Fixed to the viewport so it reaches the
 * screens that are only a centred card -- the front door has no chrome
 * to hang it off. */
export function ModeToggle() {
  const { mode, setMode } = useTheme();
  const next = mode === 'dark' ? 'light' : 'dark';
  return (
    <Corner>
      <Hint title={`Switch to ${next} mode`} placement="left" control>
        <ActionButton size="sm" aria-label={`Switch to ${next} mode`} onPress={() => setMode(next)}>
          {mode === 'dark' ? '☀' : '☾'}
        </ActionButton>
      </Hint>
    </Corner>
  );
}
